const light = {
    UserInterfaceStyle: "light",
    BrandPrimary: "#629EBF",
    BrandSecondary: "#37647D",
    LabelPrimary: "#23273B",
    LabelAlt: "#F7F7F7",
    LabelSubdiv: "#696969",
    LabelAltSubdiv: "#E35D5D",
    Background: "#FFFFFF",
    BackgroundAlt: "#F7F7F7",
    BackgroundAltElevation1: "#FFFFFF",
    Background2: "#F7F7F7",
    Background2Elevation1: "#FFFFFF",
    BackgroundGetAll: "#283942",
    TagPrimary: "#629EBF",
    TagSecondary: "#E35D5D",
    DividerPrimary: "#C4C4C4",
    NotificationAlert: "#6A7C93",
    LibraryBar: "#F7F7F7",
    PartnerPrimary: "#285F5C",
    PartnerSecondary: "#293B37",
    PartnerGradientStart: "#0F5F4B",
    PartnerGradientEnd: "#09152F"
};

const dark = {
    UserInterfaceStyle: "dark",
    BrandPrimary: "#47BEFF",
    BrandSecondary: "#5F5F5F",
    LabelPrimary: "#F7F7F7",
    LabelAlt: "#F7F7F7",
    LabelSubdiv: "#B6B8BA",
    LabelAltSubdiv: "#E35D5D",
    Background: "#2C2C2C",
    BackgroundAlt: "#363636",
    BackgroundAltElevation1: "#2C2C2C",
    Background2: "#2C2C2C",
    Background2Elevation1: "#363636",
    BackgroundGetAll: "#283942",
    TagPrimary: "#629EBF",
    TagSecondary: "#E35D5D",
    DividerPrimary: "#4F4F4F",
    NotificationAlert: "#324855",
    LibraryBar: "#283942",
    GospelPartnerPrimary: "#285F5C",
    PartnerPrimary: "#285F5C",
    PartnerSecondary: "#293B37",
    PartnerGradientStart: "#0F5F4B",
    PartnerGradientEnd: "#09152F",
};

const textStyles = {
    title1: {
        fontSize: 38,
        lineHeight: 44 + "px",
        fontWeight: 700
    },
    title2: {
        fontSize: 32,
        lineHeight: 36 + "px",
        fontWeight: 700
    },
    title3: {
        fontSize: 26,
        lineHeight: 30 + "px",
        fontWeight: 700
    },
    large: {
        fontSize: 18,
        lineHeight: 24 + "px",
        fontWeight: 700
    },
    bodyRegular: {
        fontSize: 16,
        lineHeight: 28 + "px"
    },
    bodyItalic: {
        fontSize: 16,
        lineHeight: 28 + "px"
    },
    regular: {
        fontSize: 16,
        lineHeight: 22 + "px"
    },
    regularBold: {
        fontSize: 16,
        lineHeight: 22 + "px",
        fontWeight: 700
    },
    miniRegular: {
        fontSize: 14,
        lineHeight: 18 + "px"
    },
    miniBold: {
        fontSize: 14,
        lineHeight: 18 + "px",
        fontWeight: 700
    },
    miniCap: {
        fontSize: 14,
        lineHeight: 18 + "px",
        textTransform: "uppercase",
        fontWeight: 700
    },
    miniBody: {
        fontSize: 14,
        lineHeight: 19 + "px"
    },
    tinyCap: {
        fontSize: 10,
        lineHeight: 18 + "px",
        textTransform: "uppercase"
    }
};

export {light, dark, textStyles};
